/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

import React from 'react';

import { Button, Modal } from '@mairistem/composants';

interface AssistantModalErrorStepProps {
  /** Callback appelé lors de la validation de la modal */
  onValidate: () => void;
  /** Callback appelé lors de la fermeture de la modal */
  onClose: () => void;
}

const AssistantModalErrorStep = (props: AssistantModalErrorStepProps) => {
  const { onValidate, onClose } = props;

  return (
    <Modal
      open
      closeIcon
      onClose={onClose}
      data-testid="assistant-modal-error-step"
    >
      <Modal.Header>Erreurs de saisie</Modal.Header>
      <Modal.Content>
        <span>
          Il y a des erreurs de saisies sur l&apos;étape en cours, êtes vous sur
          de vouloir continuer ?
        </span>
      </Modal.Content>
      <Modal.Actions>
        <Button
          data-testid="assistant-modal-error-step-annuler"
          content="Annuler"
          icon="cancel"
          size="tiny"
          basic
          onClick={onClose}
        />
        <Button
          data-testid="assistant-modal-error-step-valider"
          content="Valider"
          icon="check"
          positive
          onClick={onValidate}
        />
      </Modal.Actions>
    </Modal>
  );
};

export default AssistantModalErrorStep;
